// extracted by mini-css-extract-plugin
module.exports = {"root":"cart-line-items_root__gsSW5","compact":"cart-line-items_compact__DRku2","column":"cart-line-items_column__CNuzI"};